import { Box, BoxProps } from '@chakra-ui/react'

import { Caption } from 'atoms/typography'

interface ImageCaptionProps {
  'aria-hidden': BoxProps['aria-hidden']
  caption: string
}

const ImageCaption: React.FC<ImageCaptionProps> = ({ caption, ...props }) => (
  <Box bg="background" borderBottom="1px" borderColor="paleWhite" {...props}>
    <Caption p="4" color="offBlack">
      {caption}
    </Caption>
  </Box>
)

export default ImageCaption
